var _excluded = ["style", "children", "shouldWrapChildren", "wrapper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-helpers';

var TargetWrapped = function TargetWrapped(_ref, ref) {
  var style = _ref.style,
      children = _ref.children,
      _ref$shouldWrapChildr = _ref.shouldWrapChildren,
      shouldWrapChildren = _ref$shouldWrapChildr === void 0 ? true : _ref$shouldWrapChildr,
      Wrapper = _ref.wrapper,
      props = _objectWithoutProperties(_ref, _excluded);

  var isNodeElement = function isNodeElement(obj) {
    return !!obj && obj.hasOwnProperty('props');
  };

  var shouldWrap = !isNodeElement(children) || shouldWrapChildren;

  if (!shouldWrap) {
    var childNode = React.Children.only(children);
    return isNodeElement(childNode) ? /*#__PURE__*/React.cloneElement(childNode, _objectSpread({
      ref: ref
    }, props)) : null;
  }

  return /*#__PURE__*/React.createElement(Wrapper || 'div', _objectSpread({
    ref: ref,
    style: style
  }, props), children);
};

var Target = /*#__PURE__*/React.forwardRef(TargetWrapped);
Target.displayName = 'Target';
Target.propTypes = {
  /** className */
  className: PropTypes.string,

  /** style */
  style: stylePropType,

  /** children */
  children: PropTypes.node,

  /** should wrap */
  shouldWrapChildren: PropTypes.bool,

  /** wrapper element, eg: 'Div' */
  wrapper: PropTypes.any
};
export default Target;
//# sourceMappingURL=Target.js.map